<div ng-controller="taskActivityConfigController as vm" class="modal-view">
</div>